module.exports = __webpack_public_path__ + "static/media/service-img03.4f97f3e5.png";